export default __webpack_public_path__ + "static/media/Izmir-Extralight.dfa83053.woff";